export const getImageSourceFromGithub = (fileName) => {
  return {
    uri: `https://raw.githubusercontent.com/Vivek-Soni-5/ontimeurban_assets/main/${fileName}`,
  };
};